enum FinalCustomerContractProductLine {
    Alarme = 2,
    AutomacaoIP = 3,
    CIP = 8,
    ControleDeAcesso = 1,
    ControleDeAcessoLite = 9,
    ControleDeDataCenter = 4,
    GeradorDeNevoa = 6,
    Portal = 7,
    PSIM = 5
}

export default FinalCustomerContractProductLine;